import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getAccounts = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/accounts`

  const data = await apiGet({ url, token, params })
  return data
}

const getAccount = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/accounts/${params.id}`

  const data = await apiGet({ url, token, params })
  return data
}

const getAccountUserAccess = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/accounts/${params.id}/user_accesses`

  const data = await apiGet({ url, token, params })
  return data
}

export const useAccounts = ({ params, options }) => {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id: municipality_id }
  const queryFn = () => getAccounts(token, mergedParams)
  // Use JSON.stringify to ensure React Query detects all param changes
  // including pagination, search, and filter changes
  const queryKey = ['accounts', JSON.stringify(params)]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

export const useAccount = ({ params, options }) => {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id: municipality_id }
  const queryFn = () => getAccount(token, mergedParams)
  const queryKey = ['account', params.id]

  return useQuery(queryKey, queryFn, {
    ...options,
    enabled: !!params.id && (options?.enabled !== false)
  })
}

export const useAccountUserAccess = ({ params, options }) => {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id: municipality_id }
  const queryFn = () => getAccountUserAccess(token, mergedParams)
  // Use JSON.stringify to ensure React Query detects all param changes
  const queryKey = ['account-user-access', params.id, JSON.stringify(params)]

  return useQuery(queryKey, queryFn, {
    ...options,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !!params.id && (options?.enabled !== false)
  })
}
